//initial redux
import { put, call, takeEvery, fork, all, take } from "redux-saga/effects";
import importservice from "../../services/import";

const initialState = {
	output: [],
	isBusy: false,
	errors: []
};

/////////
//types
export const types = {
	UPLOAD: "screens/upload/UPLOAD",
	ON_UPLOAD: "screens/upload/ON_UPLOAD",
	PRINT: "screens/upload/PRINT",
	CLEAR: "screens/upload/CLEAR",
	ON_UPLOAD_FAILED: "screens/upload/ON_UPLOAD_FAILED"
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.UPLOAD:
				return { ...state, isBusy: true };
			case types.ON_UPLOAD:
				return { ...state, isBusy: false };
			case types.ON_UPLOAD_FAILED:
				return { ...state, isBusy: false, errors: state.errors.concat(action.payload).slice(-10) };
			case types.PRINT:
				return { ...state, output: state.output.concat(action.payload.msg) };
			case types.CLEAR:
				return { ...state, output: [] };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.onUpload()]);
	},

	*onUpload() {
		yield takeEvery(types.UPLOAD, function*({ payload }) {
			yield put(actions.print(`%C-- BEGIN UPLOAD ${payload.file.name} --`));
			let data;
			if (/\.xlsx$/.test(payload.file.name)) {
				data = yield call(importservice.importRuleSpreadsheet, payload.file);
			}
			if (!data || data instanceof Error) {
				data = data || { message: "Not a valid excel spreadsheet." };
				yield put(actions.print("%EAn Error has occurred"));
				const val = /(_RESPONSE_)(.*)$/.exec(data.message);
				if (val && val[2]) {
					data = JSON.parse(val[2]) || { message: "Not a valid excel spreadsheet." };
				} else if (/401.*?Unauthorized/g.test(data.message)) {
					data.message = "Not Authorized";
				} else {
					data.message = data.message.replace(/(_RESPONSE_)(.*)$/, "");
				}

				if (data.exceptionMessage) {
					yield put(actions.print(`Outer Exception: ${data.exceptionMessage}`));
					let ex = data.innerException;
					for (let i = 1; ex; i++, ex = ex.innerException) {
						yield put(actions.print(`Inner Exception ${i}: ${ex.exceptionMessage}`));
					}
				} else {
					yield put(actions.print(data.message));
				}

				if (data.stackTrace) {
					yield put(actions.print("%S "));
					yield put(actions.print(`%SStack: ${data.stackTrace}`));
					let ex = data.innerException;
					for (let i = 1; ex; i++, ex = ex.innerException) {
						yield put(actions.print("%S "));
						yield put(actions.print(`%SInner Stack ${i}: ${ex.stackTrace}`));
					}
					yield put(actions.print("%S "));
				}

				console.error(data);
				yield put(actions.genericAction(types.ON_UPLOAD_FAILED, data));
				yield put(actions.print(`%C-- UPLOAD ${payload.file.name} FAILED --`));
			} else {
				yield put(actions.print(`Success`));
				yield put(actions.onUpload(data));

				if (data.scope && data.scope.returnMessages) {
					for (let index = 0; index < data.scope.returnMessages.length; index++) {
						const msg = data.scope.returnMessages[index];
						if (msg.type === "Message") {
							yield put(actions.print(`%C${msg.messageText}`));
						} else if (msg.type === "Warn") {
							yield put(actions.print(`%WWarning: ${msg.messageText}`));
						}
					}
				}

				yield put(actions.print(`%C-- UPLOAD ${payload.file.name} COMPLETE --`));
			}
			yield put(actions.print(" "));
		});
	}
};

////////
//actions
export const actions = {
	upload(file) {
		return {
			type: types.UPLOAD,
			payload: {
				file
			}
		};
	},

	onUpload() {
		return {
			type: types.ON_UPLOAD,
			payload: {}
		};
	},

	print(msg) {
		return {
			type: types.PRINT,
			payload: { msg }
		};
	},

	clear() {
		return {
			type: types.CLEAR,
			payload: {}
		};
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/ui/Import/redux.js